import * as React from "react";
import { ReviewDisplay } from "@grandvisionhq/reviews";
import { useFeatureToggles } from "@grandvisionhq/state";
import { getReviewsConfigKeys } from "../../utils/modules/Reviews/utils/get-reviews-config-keys.js";
import { useProductData } from "../../../../context/context/product-context-hooks.js";
const UserReviews = ({ isSingleColumn }) => {
  const { isReviewsEnabled } = useFeatureToggles();
  const {
    product,
    activeVariant: { sku }
  } = useProductData();
  if (!isReviewsEnabled) {
    return null;
  }
  const { productId, variantId } = getReviewsConfigKeys(product, sku);
  return /* @__PURE__ */ React.createElement(ReviewDisplay, { productId, variantId, isSingleColumn });
};
export {
  UserReviews
};
//# sourceMappingURL=UserReviews.js.map
